export default __webpack_public_path__ + "static/media/mic-pitic-transparent.f2e4bb7c.png";